import { Flex, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { DefaultContainer, Image, VideoBlock } from '@/shared/ui';
import { getHowItWorks } from '../lib/howItWorks';

const HowItWorksBlock = ({ description = '' }) => {
  const { t } = useTranslation();
  const howItWorks = getHowItWorks(t);

  return (
    <DefaultContainer
      containerProps={{
        _odd: {
          bg: 'bg.light',
        },
      }}
    >
      <Heading
        alignSelf='center'
        size={{ base: 'xl', md: '2xl' }}
      >
        {t('store.productPage.hero.howItWorksHeading')}
      </Heading>
      <Text
        alignSelf='center'
        fontSize='lg'
        mt='sm'
      >
        {t(description)}
      </Text>

      <Flex
        alignItems='center'
        flexDir={{ base: 'column', md: 'row' }}
        gap='2xl'
        justifyContent='space-between'
        mt='2xl'
      >
        <Flex
          flexDir='column'
          gap='2xl'
        >
          {howItWorks?.map?.(({ imageSrc, title, text }) => (
            <Flex
              key={title}
              alignItems='center'
              gap='lg'
            >
              <Image
                alt='Steps to leave review'
                imgSizes={{
                  base: '5rem',
                  md: '6rem',
                }}
                minH={{ base: 20, md: 24 }}
                minW={{ base: 20, md: 24 }}
                src={imageSrc}
              />
              <Flex
                flexDir='column'
                gap={{ base: '2xs', md: 'xs' }}
              >
                <Heading
                  as='span'
                  fontSize='2xl'
                >
                  {title}
                </Heading>
                <Text fontWeight='semibold'>{text}</Text>
              </Flex>
            </Flex>
          ))}
        </Flex>
        <VideoBlock
          borderRadius='lg'
          h='full'
          overflow='hidden'
          src={['/store-products/landing/how-it-works.webm']}
          srcFallback={['/store-products/landing/how-it-works.mp4']}
          type='video/webm'
          typeFallback='video/mp4'
          w={{ base: 'full', md: '500px' }}
        />
      </Flex>
    </DefaultContainer>
  );
};

export default HowItWorksBlock;
